module.exports = __webpack_public_path__ + "static/media/myinfo.22991754.jpeg";